import { FC } from 'react';
import { Center, Heading, Icon } from '@chakra-ui/react';
import { WarningTwoIcon } from '@chakra-ui/icons';

export const JWTError: FC = () => {
  return (
    <Center verticalAlign={'middle'}>
      <Icon as={WarningTwoIcon} color={'orange'} boxSize={'12'} mr={3}></Icon>
      <Heading size="4xl" color={'red'}>
        Error
      </Heading>
      <Icon as={WarningTwoIcon} color={'orange'} boxSize={'12'} mr={3}></Icon>
    </Center>
  );
};
